import React, { useEffect, useState, useRef } from "react";
import { TextField, InputLabel, makeStyles } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useTranslation } from "react-i18next";
import LightTooltip from "../../LightTooltip";
import styles from "../styles";

const useStyles = makeStyles(styles);

const SearchableSelect = (props) => {
  const {
    options,
    label,
    labelIcon,
    disableClearable,
    value: initialValue,
    changeHandler,
    disabled,
    required,
    placeholder,
    style = {},
  } = props;

  const [value, setValue] = useState(null);
  const [isOverflowed, setIsOverflow] = useState(false);

  const textElementRef = useRef({});
  const classes = useStyles();
  const { t } = useTranslation();

  useEffect(() => {
    setValue(initialValue || null);
    setIsOverflow(true);
  }, [initialValue]);

  const checkOverFlow = (e) => {
    if (!value) {
      setIsOverflow(false);
    } else if (textElementRef.current && value) {
      setIsOverflow(
        textElementRef.current.scrollWidth > textElementRef.current.clientWidth
      );
    }
  };

  const handleChange = (newValue) => {
    setValue(newValue);
    if (changeHandler !== undefined && typeof changeHandler === "function") {
      changeHandler(newValue);
    }
  };

  return (
    <>
      <InputLabel className={classes.inputLabel}>
        {label}
        {required && (
          <span
            aria-hidden="true"
            className="MuiFormLabel-asterisk MuiInputLabel-asterisk"
            style={{ color: "#E30613" }}
          >
            &thinsp;*
          </span>
        )}
        {labelIcon}
      </InputLabel>
      <Autocomplete
        options={options}
        getOptionLabel={(option) => option.label || ""}
        getOptionSelected={(option, value) => {
          return (
            option === value ||
            option.value === value ||
            option.value === (value || {}).value
          );
        }}
        value={value}
        onChange={(event, newValue) => {
          handleChange(newValue);
        }}
        onBlur={checkOverFlow}
        disabled={disabled}
        required={required}
        disableClearable={disableClearable}
        margin="dense"
        size="small"
        renderInput={(params) => (
          <LightTooltip
            title={<span>{value ? value.label : ""}</span>}
            placement="top-start"
            disableFocusListener
            disableHoverListener={!isOverflowed}
            style={{ paddingBottom: 0, paddingTop: 0 }}
          >
            <TextField
              {...params}
              inputRef={textElementRef}
              size="small"
              margin="dense"
              variant="outlined"
              placeholder={
                placeholder === undefined
                  ? t("labels.common.pleaseSelect")
                  : placeholder
              }
              InputProps={{
                ...params.InputProps,
                style: { paddingTop: 5 },
              }}
            />
          </LightTooltip>
        )}
        style={style}
        loading={true}
      />
    </>
  );
};

export default SearchableSelect;
